import type { Signer } from '@cognitoforms/types/server-types/model/signer';
import { getLegacyCognito } from '../../../legacy-cognito';
import { findLegacyField, type LegacyForm } from '../../../legacy-form';

const toLegacySigner = (signer: Signer): object => {
	const Cognito = getLegacyCognito();
	return new Cognito.Signer({
		Type: Cognito.getEnumWithName(Cognito.SignerType, signer.Type),
		Value: signer.Value,
		Verification: Cognito.getEnumWithName(Cognito.SignerVerification, signer.Verification)
	});
};

export const mirrorAllowedSigners = (legacyForm: LegacyForm, parentFieldSetId: string, index: number, signers: readonly Signer[]) => {
	const field = findLegacyField(legacyForm, parentFieldSetId, index);
	if (!field)
		return;

	ExoWeb.updateArray(field.get_AllowedSigners(), signers.map(toLegacySigner));
	legacyForm.set_HasChanges(true);
};
